import { type ExecuteEventFn } from 'react-i13n';

import { I13N_TYPE_LOG } from 'Lib/constants/i13nSpec';
import { Log } from 'Lib/errors';

type ExecuteLogEventFn = (log: Log, callback?: VoidFunction) => void;

export type I13nUtils = {
  executeEvent: ExecuteEventFn;
  executeLogEvent: ExecuteLogEventFn;
  Log: typeof Log;
};

/**
 * Given an executeEvent function as an argument, returns an object with
 * utility functions for executing i13n events.
 *
 * This is intended to be consumed by another library function or React hook
 * which in turn can be used by application code.
 *
 * See docs/Instrumentation.md for more information.
 */
function createI13nUtils(executeEvent: ExecuteEventFn): I13nUtils {
  const executeLogEvent = createExecuteLogEvent(executeEvent);
  return {
    executeEvent,
    executeLogEvent,
    Log,
  };
}

function createExecuteLogEvent(executeEvent: ExecuteEventFn): ExecuteLogEventFn {
  return (log: Log, callback?: VoidFunction): void => {
    executeEvent(I13N_TYPE_LOG, { log }, callback);
  };
}

export default createI13nUtils;
